import {
  IForgotPasswordModel,
  IResetPasswordModel,
} from 'modules/account/features/forgotPassword/models';
import API from 'services/api';

export const forgotPassword = (mail: IForgotPasswordModel) => {
  return API.post('/api/users/reset-password', null, {
    params: {
      Email: mail,
    },
  });
};

export const resetPassword = (data: IResetPasswordModel) => {
  const request = { password: data.password, passwordConfirm: data.passwordConfirm };

  return API.patch(`/api/users/set-new-password/${data.token}`, request);
};

export const passwordInvite = (data: IResetPasswordModel) => {
  const passwordInviteRequest = { password: data.password, confirmPassword: data.confirmPassword };

  return API.patch(`/api/users/confirm/${data.token}`, passwordInviteRequest);
};
